/**
 * Dealer aggregate. A Dealer is a business; DealerAgents are the human
 * users employed by it (modeled in the in-platform IAM module —
 * apps/api/src/iam-users, per ADR-0011). MVP keeps the Dealer mutable
 * shape minimal: name, contact details, stock limit, risk tier,
 * suspended? — everything richer (commission terms, store layout,
 * compliance docs) lives on the persistence side.
 */
import { z } from "zod";
export const dealerSchema = z.object({
    id: z.string().uuid(),
    countryId: z.string().uuid(),
    name: z.string().min(1),
    stockLimit: z.number().int().nonnegative(),
    riskTier: z.enum(["A", "B", "C"]),
    suspendedAt: z.coerce.date().optional(),
    suspendedReason: z.string().min(10).optional(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export function makeDealer(raw) {
    const parsed = dealerSchema.parse(raw);
    return {
        id: parsed.id,
        countryId: parsed.countryId,
        name: parsed.name,
        stockLimit: parsed.stockLimit,
        riskTier: parsed.riskTier,
        ...(parsed.suspendedAt !== undefined ? { suspendedAt: parsed.suspendedAt } : {}),
        ...(parsed.suspendedReason !== undefined ? { suspendedReason: parsed.suspendedReason } : {}),
        createdAt: parsed.createdAt,
        updatedAt: parsed.updatedAt,
    };
}
export function isSuspended(dealer) {
    return dealer.suspendedAt !== undefined;
}
//# sourceMappingURL=dealer.js.map